import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { apiPrefix } from '../../utils/constants';
import * as $ from 'jquery';
import { deepCopy } from '@delon/util';
@Component({
  selector: 'icc-media-editor',
  templateUrl: './icc-media-editor.component.html',
  styleUrls: ['./icc-media-editor.component.less'],
})
export class IccMediaEditorComponent implements OnInit, OnChanges {
  constructor() {}
  selectIndex = 0;
  @Input()
  content = {
    contentType: null,
    content: null,
    mediaList: [],
    serverUrl: null,
  };
  @Input() item: any = null;
  @Input()
  variableBinds = [];
  @Input()
  showArry = [1, 1, 1, 1];
  @Input()
  disabled = false;
  @Input()
  id = new Date().getTime();
  @Input()
  mediaDownUrl = '';
  // 图片视频上传接口
  @Input()
  uploadUrl = null;
  @Input()
  imgMaxSize = 10;
  @Input()
  videoMaxSize = 300;
  @Input()
  videoTypes = ['mp4', 'flv', 'mov', 'ogg', 'rm', 'rmvb', 'wmv', 'avi', 'webm'];
  @Input()
  typeSupportDes = '推荐格式MP4、webm。';

  @Input()
  useFakeTextarea = false;

  /** 图片的最大字数 */
  @Input() textMaxLength = 500;
  // mediaUrl = './assets/3.MP4';  '?module=25&attach=7&path='
  mediaUrl = apiPrefix + '/common/attachment/download' + '?';

  vIndex = -1;

  audioTempList = [];
  imgTempList = [];
  videoTempList = [];

  contentTypes = [2, 3, 4, 5];

  indexToContentTypeMap = {
    '0': 2,
    '1': 3,
    '2': 4,
    '3': 5,
  };
  contentTypeToIndexMap = {
    '2': 0,
    '3': 1,
    '4': 2,
    '5': 3,
  };

  /** 文本类型-获取文本框的光标 */
  @Output() getPosition = new EventEmitter();
  /** 文本类型-文本框内容改变 */
  @Output() textContentChange = new EventEmitter();

  @Output() tabchange: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {}

  ngOnChanges() {
    // 根据给定showArry重置index 与 contentType的映射关系
    let index = 0;
    for (let i in this.showArry) {
      if (this.showArry[i] === 1) {
        this.indexToContentTypeMap[index] = this.contentTypes[i];
        this.contentTypeToIndexMap[this.contentTypes[i]] = index;
        index++;
      }
    }
    this.init();
  }

  init() {
    if (this.content.contentType) {
      this.selectIndex = this.contentTypeToIndexMap[this.content.contentType];
    }
    if (this.content.mediaList) {
      const tmpList = this.content.mediaList.map(media => {
        let element = deepCopy(media);
        element.url = this.mediaUrl + element.url;
        return element;
      });
      if (this.content.contentType === 3) {
        this.imgTempList = tmpList;
      }
      if (this.content.contentType === 4) {
        this.videoTempList = tmpList;
      }
      if (this.content.contentType === 5) {
        this.audioTempList = tmpList;
      }
    }
  }

  getCaretPosWithEvent(event) {
    let field = event.target;
    this.vIndex = field.selectionStart;
    this.getPosition.next(this.vIndex);
  }

  emitCursorOffset($event) {
    this.getPosition.next($event);
  }

  toMediaList(tempList) {
    if (!tempList) {
      return [];
    }
    return tempList.map(tmp => {
      let element = deepCopy(tmp);
      element.url = element.url.substr(this.mediaUrl.length);
      return element;
    });
  }

  contentTypeChange(contentType, content) {
    if (contentType == 3) {
      content.mediaList = this.toMediaList(this.imgTempList);
    }
    if (contentType == 4) {
      content.mediaList = this.toMediaList(this.videoTempList);
    }
    if (contentType == 5) {
      content.mediaList = this.toMediaList(this.audioTempList);
    }
    if (contentType == 2) {
      content.mediaList = [];
    }
  }

  // 抖音视频上传成功，返回地址
  uploadSuccess(mediaUrl: any, content) {
    this.videoTempList = [
      {
        name: mediaUrl.fileName,
        url: this.mediaUrl + this.mediaDownUrl + mediaUrl.filePath,
        size: mediaUrl.fileSize,
      },
    ];
    content.mediaList = this.toMediaList(this.videoTempList);
  }

  // 抖音视频失败，清楚内容
  uploadVideoFail(mediaUrl: any, content) {
    content.mediaList = [];
    this.videoTempList = [];
  }

  VideoRemove(content) {
    content.mediaList = [];
    this.videoTempList = [];
  }

  // 失败取消移除,都能删掉videoUrl
  uploadVideoCancel(mediaUrl: any, content) {
    content.mediaList = [];
    this.videoTempList = [];
  }

  // 抖音图片上传成功，返回地址
  uploadImageSuccess(mediaUrl: any, content) {
    this.imgTempList = [
      {
        name: mediaUrl.fileName,
        url: this.mediaUrl + this.mediaDownUrl + mediaUrl.filePath,
        size: mediaUrl.fileSize,
      },
    ];
    content.mediaList = this.toMediaList(this.imgTempList);
  }
  // 抖音图片上传失败,清楚内容
  uploadImageFail(mediaUrl: any, content) {
    content.mediaList = [];
    this.imgTempList = [];
  }

  // 抖音图片删除成功，返回地址
  removeImageSuccess(imageIndex: any, content) {
    content.mediaList = [];
    this.imgTempList = [];
  }

  // 上传音频成功，返回地址
  uploadAudioSuccess(audioUrl: any, content) {
    const index = audioUrl.indexOf('&path=');
    let url;
    if (index > 0) {
      url = audioUrl.substring(index + 6, audioUrl.length);
    } else {
      url = audioUrl;
    }
    this.audioTempList = [
      {
        name: url,
        url: this.mediaUrl + this.mediaDownUrl + url,
      },
    ];
    content.mediaList = this.toMediaList(this.audioTempList);
  }
  // 抖音图片上传失败,清楚内容
  removeAudio(mediaUrl: any, content) {
    content.mediaList = [];
    this.audioTempList = [];
  }

  selectChange(value) {
    this.selectIndex = value.index;
    this.content.contentType = this.indexToContentTypeMap[this.selectIndex];
    this.contentTypeChange(this.content.contentType, this.content);
    this.tabchange.emit(this.selectIndex);
  }

  insertVar(v) {
    if (this.content.content == null || this.content.content === undefined) {
      this.content.content = '';
    }
    this.content.content = this.content.content.slice(0, this.vIndex) + '${' + v.code + '}' + this.content.content.slice(this.vIndex);
    this.vIndex = this.vIndex + v.code.length + 3;
  }

  varMouseOver(evt) {
    $(evt.target).addClass('var-active');
  }

  varMouseLeave(evt) {
    $(evt.target).removeClass('var-active');
  }

  handelTextContentChange($event, item) {
    let param = {
      $event: $event,
      item: item,
    };
    this.textContentChange.emit(param);
  }
}
